<template>
  <!-- :bodyStyle="{paddingTop:'10px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <search-page-view
      ref="table"
      rowKey="id"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="operation">
        <a-input-search placeholder="请输入商品标题" @search="onSearch" style="max-width: 400px;"/>
        <a-button style="margin-left: 10px" type="primary" icon="plus" @click="createCodeEvent(0,0)">新建</a-button>
      </a-form-item>
      <template slot="typeSlots" slot-scope="data">
        <span>{{ data.record.categoryId | productTypeName }}</span>
      </template>
      <div slot="action" slot-scope="data">
        <a @click="createCodeEvent(data.record.productId,data.record.id)">编辑</a>
        <span v-if="data.record.deleteStatus==1">
        <a-divider type="vertical"/>
        <a-popconfirm title="是否要删除当前拼团？" @confirm="deleteGroup(data.record)">
          <a>删除</a>
        </a-popconfirm>
      </span>
        <a-divider type="vertical"/>
        <a @click="onPreview(data.record)">预览</a>
      </div>
    </search-page-view>
  </a-card>
</template>

<script>
import RouterSwitchHelper from '@/utils/helper/RouterSwitchHelper'

export default {
  name: 'GroupServiceList',
  components: {},
  data() {
    return {
      submitLoading: false,
      currentFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        productName: '', // 优惠券名称
        platformId: this.getPlatformConfig().platformId
      },
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '商品标题',
          dataIndex: 'productName',
          width: '30%'
        },
        {
          title: '拼团套餐',
          dataIndex: 'togetherSkuCount'
        },
        {
          title: '类型',
          dataIndex: 'categoryId',
          scopedSlots: { customRender: 'typeSlots' }
        },
        {
          title: '创建时间',
          dataIndex: 'gmtCreate'
        },
        {
          title: '状态',
          dataIndex: 'statusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '160px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {

  },
  activated() {
    this.getLogUtils().logWithTag('拼团activated')
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'GroupServiceList', title: '拼团商品' },
      { name: 'GroupOrderList', title: '拼团订单' }
    ])
    if (this.$route.query.updateFlag) {
      this.getLogUtils().logWithTag('activated', this.$route.query.updateFlag)
      this.$refs.table.refresh(true)
    }
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getServerApiService().post('shopping/together/list', params)
    },
    onSearch(value) {
      this.queryParams.productName = value
      this.$refs.table.refresh(true)
    },
    // 新增内容
    createCodeEvent(proId, groupId) {
      this.$router.push({
        name: 'NewGroup',
        query: {
          proId: proId,
          groupId: groupId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    //预览手机页面的详情
    onPreview(record) {
      const merchantId = this.$store.getters.userInfo.merchantId
      const character = 1
      const params = {
        p: `${character}_${merchantId}_${merchantId}`
      }
      let domainUrl = this.$store.getters.platformConfig.h5Url
      RouterSwitchHelper.toProductDetails(domainUrl, record.productId, record.categoryId, 0, params)
    },
    deleteGroup(data) {
      let params = {
        categoryId: data.categoryId,
        merchantId: this.queryParams.merchantId,
        platformId: this.queryParams.platformId,
        productId: data.productId
      }
      this.getHttpServices().getServerApiService().post('shopping/together/list/delete', params)
        .then(res => {
          this.$message.success('删除成功')
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style scoped lang="less">
.herder-set {
  text-align: right;
  float: right;

  a {
    padding-left: 10px;
  }
}

.title-text {
  height: 26px;
  line-height: 26px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.65);
  padding-left: 15px;
}

.w100 {
  width: 100px;
  height: 100px;
}
</style>